import { useEffect, useState } from 'react';

// A phone's keyboard belongs over a screen, not inside it: a native app keeps
// its own height and lets the keyboard cover the bottom of it, and the field
// being typed into scrolls up inside the screen's own scroller. So a full
// screen is simply `fixed inset-0` — the layout viewport, which a keyboard
// never changes — and nothing here follows the visual viewport, whose every
// small correction would otherwise bump the screen under a finger.
//
// A screen is full where the display is small in EITHER direction: a phone held
// sideways is 932 x 430, which a width-only breakpoint reads as a desktop and
// then draws a dialog taller than the display. §20
const PHONE = 640;

export function fillsScreen(win: Window): boolean {
  return win.innerWidth < PHONE || win.innerHeight < PHONE;
}

export function useFullScreen(): boolean {
  const [full, setFull] = useState(() => fillsScreen(window));
  useEffect(() => {
    const follow = (): void => setFull(fillsScreen(window));
    window.addEventListener('resize', follow);
    follow();
    return () => window.removeEventListener('resize', follow);
  }, []);
  return full;
}
